import React from 'react'
import './headerBlogMain.css';

function HeaderBlogMain() {
  return (
      <section id='home' className='section_headerBlogMain'>
        <div className='container headerBlogMain_main'>

          <h1>Blog</h1>
           <p className='headerBlogMain_subtitle'>Latest from Ponos Technology</p>
         
        </div>
    </section>
  )
}

export default HeaderBlogMain
